export const categoriesData = [
  {
    CategoryName: "Technology",
    SubCategoryName: "Hardware Cost",
    key: "1",
  },
  {
    CategoryName: "Taxes",
    SubCategoryName: "Payroll Taxes",
    key: "2",
  },
  {
    CategoryName: "Recruitment",
    SubCategoryName: "Advertisement",
    key: "3",
  },
  {
    CategoryName: "Compensation",
    SubCategoryName: "Incentive",
    key: "4",
  },
  {
    CategoryName: "Travel",
    SubCategoryName: "Business Travel",
    key: "5",
  },
  {
    CategoryName: "Internship",
    SubCategoryName: "Stipends",
    key: "6",
  },
  {
    CategoryName: "Employee Engagement",
    SubCategoryName: "Engagement Activities",
    key: "7",
  },
  {
    CategoryName: "Employee Benefits",
    SubCategoryName: "Healthcare Benefits",
    key: "8",
  },
  {
    CategoryName: "Corporate Events",
    SubCategoryName: "Decorations",
    key: "9",
  },
  {
    CategoryName: "Compliance",
    SubCategoryName: "Performance Appraisal",
    key: "10",
  },
];
